import { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { Alert } from '../../types';

/**
 * Service for alert-related API calls
 */
export const alertService = {
  /**
   * Get alerts
   * @param interval - Optional time interval filter
   */
  getAlerts: (interval?: string): Promise<AxiosResponse<Alert[]>> => {
    return apiClient.get('/api/alerts', { params: { interval } });
  },

  /**
   * Perform an action on an alert
   * @param alertId - The alert ID
   * @param action - The action to perform (e.g., 'read', 'dismiss')
   */
  performAlertAction: (alertId: string, action: string): Promise<AxiosResponse> => {
    return apiClient.post(`/api/alerts/${alertId}/${action}`);
  },

  /**
   * Perform a bulk action on multiple alerts
   * @param action - The action to perform (e.g., 'read-all', 'dismiss-all')
   * @param ids - Array of alert IDs
   */
  performBulkAlertAction: (action: string, ids: string[]): Promise<AxiosResponse> => {
    return apiClient.post(`/api/alerts/${action}`, ids);
  },
};
